import { useTranslate } from '@ur-solutions/react-hooks'
import {
  IconShortcut,
  ShortcutsWrapper,
} from '@/components_deprecated/Shortcuts'
import { PermissionsRequired } from '@/containers/permission-containers'
import { useModuleConfigs } from '@/modules/companies/CompanySettings/hooks'
import React from 'react'
import { isMobile } from 'react-device-detect'
import styled from 'styled-components'
import { PLANNER_URL } from '@/utils'
import { PERMISSIONS } from '@/utils/permissions'
import { writeAuthCookie } from '../login/util'

const Wrapper = styled.section`
  max-width: 100%;
`

export const DashboardShortcuts: React.FC = () => {
  const translations = useTranslate({
    shortcuts: 'common.shortcuts',

    forum: 'common.forum',
    users: 'common.users',
    drivingData: 'common.driving-data',
    terminal: 'common.terminal',
    issues: 'common.issues',
    infringements: 'common.infringements',
    hourlist: 'common.hourlist',
    absences: 'common.absences',
    driversHandbook: 'common.drivers-handbook',
    handbook: 'common.handbook',
    driverPlanner: 'common.driver-planner',

    confirmHours: 'salary.confirm-hours',
    workTimeAndSalary: 'salary.work-time-and-salary',
  })

  const { active } = useModuleConfigs()

  const handbookShortcutText = isMobile
    ? translations.handbook
    : translations.driversHandbook

  return (
    <Wrapper>
      <h2>{translations.shortcuts}</h2>

      <ShortcutsWrapper $alignWithSpaceBetween={true}>
        {active.forum && (
          <PermissionsRequired permissions={['forum.view_thread']}>
            <IconShortcut
              linkProps={{ to: '/forum' }}
              iconProps={{ icon: 'chat' }}
              text={translations.forum}
            />
          </PermissionsRequired>
        )}

        {isMobile && (
          <PermissionsRequired permissions={[PERMISSIONS.users.view.user]}>
            <IconShortcut
              linkProps={{ to: '/users' }}
              iconProps={{ icon: 'users' }}
              text={translations.users}
            />
          </PermissionsRequired>
        )}

        {active.activities && (
          <PermissionsRequired permissions={['activities.view_driveractivity']}>
            <IconShortcut
              linkProps={{ to: '/activities' }}
              iconProps={{ icon: 'truck' }}
              text={translations.drivingData}
            />
          </PermissionsRequired>
        )}

        {active.issues && (
          <PermissionsRequired permissions={['issues.view_issue']}>
            <IconShortcut
              linkProps={{ to: '/issues' }}
              iconProps={{ icon: 'warning' }}
              text={translations.issues}
            />
          </PermissionsRequired>
        )}

        {active.infringements && (
          <PermissionsRequired
            permissions={['infringements.view_infringement']}
          >
            <IconShortcut
              linkProps={{ to: '/infringements' }}
              iconProps={{ icon: 'infringement' }}
              text={translations.infringements}
            />
          </PermissionsRequired>
        )}

        {active.timesheets && (
          <PermissionsRequired permissions={['timesheets.view_timeentry']}>
            <IconShortcut
              linkProps={{ to: '/time-entries', className: 'extra-padding' }}
              iconProps={{ icon: 'clock', width: '30px' }}
              text={translations.hourlist}
            />
          </PermissionsRequired>
        )}

        {active.absences && (
          <PermissionsRequired
            permissions={[
              PERMISSIONS.timesheets.view.absence,
              PERMISSIONS.users.view.user,
            ]}
          >
            <IconShortcut
              linkProps={{ to: '/absences' }}
              iconProps={{ icon: 'user-x' }}
              text={translations.absences}
            />
          </PermissionsRequired>
        )}

        {active.handbook && (
          <PermissionsRequired
            permissions={[PERMISSIONS.handbook.view.manualentry]}
          >
            <IconShortcut
              linkProps={{ to: '/handbook' }}
              iconProps={{ icon: 'book' }}
              text={handbookShortcutText}
            />
          </PermissionsRequired>
        )}

        {active.driverPlanner && (
          <PermissionsRequired permissions={['planner.view_calendaritem']}>
            <IconShortcut
              external
              href={PLANNER_URL}
              iconProps={{ icon: 'calendar-week' }}
              text={translations.driverPlanner}
              beforeNavigate={() => writeAuthCookie()}
            />
          </PermissionsRequired>
        )}
        {active.salary && (
          <PermissionsRequired
            permissions={[PERMISSIONS.salary.approve.workperiod]}
          >
            <IconShortcut
              linkProps={{ to: '/approve-work-periods' }}
              iconProps={{ icon: 'users' }}
              text={translations.confirmHours}
            />
          </PermissionsRequired>
        )}
        {active.salary && (
          <PermissionsRequired
            permissions={[PERMISSIONS.salary.view.salarybase]}
          >
            <IconShortcut
              linkProps={{ to: '/work-periods' }}
              iconProps={{ icon: 'users' }}
              text={translations.workTimeAndSalary}
            />
          </PermissionsRequired>
        )}
      </ShortcutsWrapper>
    </Wrapper>
  )
}
